import cx from "classnames";
import React from "react";

import { ProductEntity } from "@/mk2/apps/bazaar/schemas";
import { bazaarUrl } from "@/mk2/apps/bazaar/urls";
import { Link } from "@/mk2/components/Link";
import { BZ2_PRODUCTS } from "@/mk/autogenerated/translations/ProductInfoHeader.5a1fd5fdd881127131620f058dac1817";
import { QUALITY_VALUES } from "@/mk/bazaar/common/enums";
import {
    dict as CategoriesDict,
    Category,
    LeafCategory,
    getLabel,
    getParentCategory,
} from "@/mk/bazaar/product/categories";
import { bazaar_single_page_product_grid_category_url } from "@/mk/urls/functions";

import styles from "./ProductInfoHeader.mscss";

interface OwnProps {
    className?: string;
    product: ProductEntity;
}

type Props = OwnProps;

const ProductInfoHeader: React.FunctionComponent<Props> = ({ className, product }) => {
    const categoryProperty = product.properties.find((p) => p[0] === "cat");
    const categoryName = categoryProperty ? categoryProperty[1] : null;
    const category: LeafCategory = categoryName ? CategoriesDict()[categoryName] : null;
    let parentCategory: Category = categoryName ? getParentCategory(categoryName) : null;

    const parents: React.ReactNode[] = [];
    while (parentCategory) {
        parents.push(
            <React.Fragment key={parentCategory.name}>
                {" > "}
                <Link to={bazaar_single_page_product_grid_category_url(parentCategory.slug)}>
                    {getLabel(parentCategory.name)}
                </Link>
            </React.Fragment>,
        );
        parentCategory = getParentCategory(parentCategory.name);
    }

    return (
        <div className={cx(styles.ProductInfoHeader, className)}>
            <div className={styles.ProductInfoHeader__breadcrumb}>
                <Link to={bazaarUrl}>{BZ2_PRODUCTS}</Link>

                {parents.length > 0 && parents.reverse()}

                {category && (
                    <>
                        {" > "}
                        <Link to={bazaar_single_page_product_grid_category_url(category.slug)}>
                            {getLabel(category.name)}
                        </Link>
                    </>
                )}
            </div>

            <div
                className={cx(
                    styles.ProductInfoHeader__quality,
                    styles[`ProductInfoHeader__quality--${product.quality}`],
                )}
            >
                {QUALITY_VALUES[product.quality].label}
            </div>
        </div>
    );
};

ProductInfoHeader.displayName = "ProductInfoHeader";

export default React.memo<Props>(ProductInfoHeader);
